import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { quotationForClientSchema } from './schemas';

export const quotationForClientQueryOptions = (approvalKey: string) =>
  queryOptions({
    queryKey: QueryKeys.misc.quotationForClient(approvalKey),
    queryFn: async () => {
      const { data: quotationForClient } = await fetchJson(`/quotation-for-client/${approvalKey}`, {
        schema: apiResourceSchema(quotationForClientSchema),
      });

      return quotationForClient;
    },
    staleTime: Infinity,
    gcTime: Infinity,
  });

export const useQuotationForClient = (approvalKey: string) => {
  return useQuery(quotationForClientQueryOptions(approvalKey));
};
